<template>
  <div class="row">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.offersSlider')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-md-12 col-md-12 ">
      <div class="card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="card-content row">
          <div class="col-sm-12 mb-10">
            <div class="pull-left">
              <label for="" id="homepage_text">{{homepageText}}</label>
              <template>
                <p-switch v-model="homepage" type="success" ></p-switch>
              </template>
              <!-- <el-input v-model="filters[0].value" placeholder="Search" class="icon-search"></el-input> -->
            </div>
            <div class="pull-right ">
              <router-link v-if="!homepage" class="btn btn-icon btn-info add mar-bt-20" :to="{ path: '/marketing/offers/add'}" :title="$t('general.add') + ' ' + $t('marketingOffers.single')">
                <img src="/static/img/icons/add.png">
                {{ $t('general.add') }}
              </router-link>
              <button v-else class="btn add mar-bt-20" @click="triggerModal = !triggerModal">
                <img src="/static/img/icons/add.png">
                {{$t('marketingOffers.addGroup')}}
              </button>
            </div>
          </div>
          <!-- banners table -->
          <table class="table width-table" ref="sortableTable" v-if="!homepage">
            <thead>
                  <tr>
                    <th width="5%"></th>
                    <th width="15%">{{$t('marketingOffers.image')}}</th>
                    <th width="15%">{{$t('marketingOffers.title')}}</th>
                    <th width="10%">{{$t('marketingOffers.status')}}</th>
                    <th width="10%">{{$t('marketingOffers.linkType')}}</th>
                    <th width="25%">{{$t('marketingOffers.startEndDate')}}</th>
                    <th width="10%">{{$t('marketingOffers.actions')}}</th>
                    <th width="25%"></th>
                  </tr>
            </thead>
            <draggable v-model="tableData" :element="'tbody'" @end="adjustSort">
              <template v-for="(item, index) in tableData">
                <tr class="sortableRow" :key="item.id">
                  <td >
                    <!-- <button style="cursor: move" class="btn"><v-icon>drag_handle</v-icon></v-btn> -->
                      <i style="cursor: move; color: #7C8DB5;" class="fa fa-arrows sortHandle"></i>
                  </td>
                  <td >
                    <div class="cell">
                      <div class="image-table">
                        <img v-bind:src="(item.image)?item.image : ''" />
                      </div>
                    </div>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>
                    <template>
                      <p-switch v-model="item.active" type="success" @input="handleActive(item)"></p-switch>
                    </template>
                  </td>
                  <td>{{ item.link_type }}</td>
                  <td> {{formatDate(item.date_start)}} - {{formatDate(item.date_end)}}</td>
                  <td>
                    <a class="btn btn-danger btn-icon delete mar-rt-10" @click="handleDelete(index, item, $event)" :title="$t('general.delete')">
                      <img src="/static/img/icons/icon-close.png">
                      {{$t('general.delete')}}
                    </a>
                  </td>
                  <td class="edit-icon-pointer" @click="goToRecord(item,[],[], $event)">
                    <div class="edit">
                      <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                    </div>
                  </td>
                </tr>
              </template>
            </draggable>
          </table>
          <group v-else :triggerModal="triggerModal"></group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import Group from './Group/Group.vue'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      draggable,
      // GeneralTopBar,
      Group
    },
    watch: {
      homepage (newValue, oldValue) {
        this.homepageText = newValue === true ? this.$t('marketingOffers.offers') : this.$t('marketingOffers.banners')
        this.updateHomepage(newValue)
      }
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        homepage: this.$session.get('selectedCompanyData')['homepage'],
        homepageText: '',
        group_name: '',
        triggerModal: false,
        actionCol: {
          label: 'Delete',
          props: {
            align: 'center'
          },
          buttons: [{
            props: {
              type: 'danger',
              icon: 'el-icon-delete',
              class: 'btn btn-orange btn-fill'
            },
            handler: (index, row) => {
              this.handleDelete(index, row)
            },
            label: 'delete'
          }]
        },
        paginationDef: {
          pageSize: 999,
          currentPage: 1,
          pageSizes: [999],
          show: false,
          disabled: true
        },
        searchQuery: '',
        propsToSearch: ['name', 'status', 'type', 'discount'],
        tableColumns: [],
        tableData: [],
        tableOffersData: [],
        tableOffersColumns: [],
        filters: [
          {
            value: '',
            prop: ['title', 'link_type', 'date_start', 'date_end']
          }
        ]
      }
    },
    created () {
      this.initPage()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.initPage()
      },
      initPage () {
        this.$nextTick(() => {
          this.loading = true
        })

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          use_sort_order: 'asc'
        }

        let homepageOption = this.$session.get('selectedCompanyData')['homepage']
        this.homepageText = homepageOption ? this.$t('marketingOffers.offers') : this.$t('marketingOffers.banners')
        if (homepageOption) {
          this.getOffers(data)
        } else {
          this.getBanners(data)
        }
      },
      getBanners (data) {
        this.apiRequest('/banner', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      getOffers (data) {
        this.apiRequest('/homepage-offer', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableOffersData = response.data
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      updateHomepage (option) {
        // update company option regarding homepage
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          option: option ? 1 : 0
        }

        this.apiRequest('/homepage-offer/update-company', 'POST', data, (response) => {
          if (response.status) {
            let selected = this.$session.get('selectedCompanyData')
            selected.homepage = option
            this.$session.set('selectedCompanyData', selected)
            if (option) {
              this.getOffers(data)
            } else {
              this.getBanners(data)
            }
            swal(
              this.$t('general.success') + '!',
              'Optiune homepage updatata',
              'success'
            ).catch(() => {})
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      handleActive (row) {
        let actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${row.title}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              active: row.active ? 1 : 0,
              id: row.id
            }

            var self = this
            this.apiRequest('/banner/' + row.id, 'PUT', data, function (response) {
              if (response.status) {
                swal(
                  self.$t('general.success') + '!',
                  '',
                  'success'
                ).catch(() => {})
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          row.active = !row.active
        })
      },
      goToRecord (row, event, column) {
        if (column.label !== 'Actions' && column.label !== 'Status') {
          this.globalGoToRecord(row, event, column, '/marketing/offers/edit/')
        }
      },
      adjustSort (evt) {
        if (this.tableData.length > 1) {
          var idx = evt.newIndex
          var after, before, sortOrder

          if (idx === 0) {
            // console.warn('first')
            before = 0
            after = this.tableData[idx + 1].sort_order
          } else if ((idx + 1) === this.tableData.length) {
            // console.warn('last')
            before = this.tableData[idx - 1].sort_order
            after = parseFloat(before) + 1
          } else {
            // console.warn('middle')
            before = this.tableData[idx - 1].sort_order
            after = this.tableData[idx + 1].sort_order
          }

          sortOrder = (parseFloat(before) + parseFloat(after)) / 2
          var id = this.tableData[idx].id

          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }
          var self = this
          this.apiRequest('/banner/' + id, 'PUT', data, function (response) {
            if (response.status !== true) {
              swal(
                {
                  title: '',
                  text: self.$t('validations.dataCouldNotBeSaved'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          })
        }
      },
      handleDelete (index, row, event) {
        var self = this
        event.stopPropagation()
        var btnCounter = 3
        swal({
          text: self.$t('marketingCampaigns.areYouSureDelete') + ` '${row.title}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/banner/' + row.id, 'DELETE', data, function (response) {
              if (response.status === true) {
                swal(
                  '',
                  self.$t('marketingOffers.offerDeleted'),
                  'success'
                )
                self.tableData.splice(index, 1)
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }).catch(() => {
          //
        })
        swal.disableConfirmButton()
        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + '(' + btnCounter + ')'
          } else {
            clearInterval(btnInterval)
            swal.getConfirmButton().textContent = self.$t('general.yes')
            swal.enableConfirmButton()
          }
        }, 1000)
      }
    }
  }
</script>
<style scoped>
  .border-bottom {
    border-bottom: 1px solid #ccc;
  }
  .groupModal__footer {
    border-top: 1px solid #ccc;
    padding: 10px;
  }
  .header {
    padding-left: 15px;
  }
  .mb-5 {
    margin-bottom: 5px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  #homepage_text {
    font-size: 18px;
    font-weight: 600;
    margin-right: 10px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/Offers.vue